import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { SidePanelContentSlot } from '@dreryk/react-components';

import { AddNoteModal } from '~legacy.patient';

import { notesTranslationKeys } from '../../translations';

import { NotesSidePanelList } from './NotesSidePanelList';

type NotesSidePanelContentSlotProps = {
   readonly patientId: PatientSimple['id'];
};

const NotesSidePanelContentSlot = (props: NotesSidePanelContentSlotProps): JSX.Element => {
   return (
      <SidePanelContentSlot headerText={notesTranslationKeys.notes}>
         <AddNoteModal patientId={props.patientId} />
         <NotesSidePanelList patientId={props.patientId} />
      </SidePanelContentSlot>
   );
};

export { NotesSidePanelContentSlot };
